import AppCard from './AppCard.vue'

export default AppCard
